type SeparatorProps = {}

export const Separator = ({}: SeparatorProps) => {
  return <div className="w-full border-b border-neutral-100"></div>
}
